import { ref, computed, Ref } from '@vue/composition-api';
import { IdentityInfo, IDENTITY_TYPE_MAP, IdentityItem } from '@tt4b/ttam-enums';

type Identity = IdentityInfo & IdentityItem;
const { BC_AUTH_TT, TTS_TT, TT_USER, AUTH_CODE_USER } = IDENTITY_TYPE_MAP;
// 对identity list二次处理, 可用 & 不可用拆分，排序，分组
export function useIdentityDisplayList({ dataSource }: { dataSource: Ref<Array<Identity>> }) {
  const keywords = ref('');
  const curDataSource = computed(() =>
    dataSource.value.filter(
      identity => identity.displayName?.includes(keywords.value) || identity.identityId?.includes(keywords.value),
    ),
  );
 
  const identitySortFn = (
    { available }: { available: boolean } = {
      available: true,
    },
  ) => {
    // 用于排序
    const sortDataSource = curDataSource.value.filter(identity => identity.disabled !== available);
    const identityListForTtsTT = sortDataSource.filter(identity => identity.identityType === TTS_TT);
    const identityListForUserTT = sortDataSource.filter(identity => identity.identityType === TT_USER);
    const identityListForBcAuthTT = sortDataSource.filter(identity => identity.identityType === BC_AUTH_TT);
    const identityListForUserAuthTT = sortDataSource.filter(identity => identity.identityType === AUTH_CODE_USER);
    return [
      ...identityListForTtsTT,
      ...identityListForUserTT,
      ...identityListForBcAuthTT,
      ...identityListForUserAuthTT,
    ];
  };
  const identityDisplayList = computed(() => identitySortFn({ available: true }));
  const unAvailableIdentityDisplayList = computed(() => identitySortFn({ available: false }));
  const isShowTtbaAddBtn = computed(
    () => !dataSource.value.filter(identity => identity.identityType === TT_USER).length,
  );
  return {
    keywords,
    identityDisplayList,
    unAvailableIdentityDisplayList,
    isShowTtbaAddBtn,
  };
}
